import { _Chain, chain } from 'underscore';
import { IReturnProductRailways } from '@ve/pages/hotel/types';
import { IRailwayToursListItem } from '@ve/components/railwayTours/railwayToursListPopup/common/types';

export const groupRailwaysTourProducts = (railwayTourProducts: IReturnProductRailways[]): _Chain<any, IReturnProductRailways[][]> => (chain(railwayTourProducts)
    .groupBy((railwayTourProduct) => {
        const backLegs = railwayTourProduct.routes[0]?.back?.legs;
        if (!backLegs) return `${railwayTourProduct.operator.id}~${railwayTourProduct.checkInDate}~${railwayTourProduct.nightInHotel}`;
        const endDate = backLegs[backLegs.length - 1].arrivalDate;

        // ключ чтобы убрать из выдачи туры с точно такими же ЖД, но с другими тарифами самого отеля
        return `${railwayTourProduct.operator.id}~${railwayTourProduct.checkInDate}~${railwayTourProduct.nightInHotel}~${endDate}`;
    }).values());

export const railwayToursListAdapter = (railwayTourProducts: IReturnProductRailways[]): IRailwayToursListItem[] => groupRailwaysTourProducts(railwayTourProducts)
    .map((railwayTourProductsGrouped) => {
        const railwayTourProduct = railwayTourProductsGrouped[0];

        return {
            price: railwayTourProduct.price,
            tourId: railwayTourProduct.id,
            checkInDate: railwayTourProduct.checkInDateRange.from,
            checkOutDate: railwayTourProduct.checkInDateRange.to,
            nightsInHotel: railwayTourProduct.nightInHotel,
            routes: railwayTourProduct.routes,
        };
    }).value();